import { splitHyphenWords } from '../data/no-wrap-hyphens.js'

/** Renders text so a hyphenated word never breaks at its hyphen. */
export function NoWrapHyphens({ text }: { text: string }) {
  return (
    <>
      {splitHyphenWords(text).map((part, i) =>
        part.nowrap ? (
          <span key={i} className="whitespace-nowrap">
            {part.text}
          </span>
        ) : (
          part.text
        )
      )}
    </>
  )
}
